import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { ServiceService } from 'packages/client/src/app/services/service.service';
import { ServiceBasicInfoGridObject } from '@it2go/types';

interface State {
    serviceBasicInfos: ServiceBasicInfoGridObject | null,
}

const defaultState: State = {
    serviceBasicInfos: null,
};

@Injectable()
export class ServiceBasicInfoStore extends ComponentStoreFactory<State, ServiceService> {

    public readonly svc = inject(ServiceService);

    constructor() {
        super(defaultState, inject(Store), inject(ServiceService));
    }
}
